<template>
  <div class="header-container">
    <div class="row m-0 box">
      {{ $t() }}
      <div class="col left">
        <div class="logo" ref="logo">
          <router-link :to="{ name: 'Home' }">
            <img src="@images/logo.png" />
          </router-link>
        </div>
      </div>
      <div class="col-6 center row m-0 menu text-center">
        <div class="col">
          <router-link :to="{ name: 'About' }">
            {{ $t("message.menu[0]") }}</router-link
          >
        </div>
        <div class="col">
          <router-link :to="{ name: 'Product' }">{{
            $t("message.menu[1]")
          }}</router-link>
        </div>
        <div class="col">
          <router-link :to="{ name: 'Contact' }">{{
            $t("message.menu[2]")
          }}</router-link>
        </div>
        <div class="col">
          <router-link :to="{ name: 'Available' }">{{
            $t("message.menu[3]")
          }}</router-link>
        </div>
      </div>
      <div class="col right">
        <div class="lang">
          <b-dropdown id="dropdown-lang" right :text="$i18n.locale">
            <b-dropdown-item
              v-for="lang in $i18n.availableLocales"
              :key="lang"
              @click="$i18n.locale = lang"
            >
              {{ lang }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="bars">
          <transition name="fade" mode="out-in">
            <img
              src="@images/bars.svg"
              ref="bars"
              id="bars"
              v-if="menuFade == true"
              @click="menuFade = false"
              key="1"
            />
            <img
              src="@images/times.svg"
              ref="times"
              id="times"
              v-else
              @click="menuFade = true"
              key="2"
            />
          </transition>
        </div>
      </div>
    </div>
    <transition name="menu-fade">
      <div class="fade-menu" v-show="!menuFade" @click="menuFade = true">
        <div class="fade-menu-box">
          <div class="fade-menu-item">
            <router-link :to="{ name: 'Home' }">
              {{ $t("message.menu[4]") }}</router-link
            >
            <router-link :to="{ name: 'About' }">
              {{ $t("message.menu[0]") }}</router-link
            >
            <router-link :to="{ name: 'Product' }">{{
              $t("message.menu[1]")
            }}</router-link>

            <router-link :to="{ name: 'Contact' }">{{
              $t("message.menu[2]")
            }}</router-link>

            <router-link :to="{ name: 'Available' }">{{
              $t("message.menu[3]")
            }}</router-link>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";

export default {
  data() {
    return {
      menuFade: true,
      activeRoute: "Home"
    };
  },
  methods: {},
  mounted() {},
  watch: {
    "$route.name": {
      handler: function(data) {
        this.activeRoute = data;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease-out, transform 0.1s ease-in-out;
}

.fade-leave-active {
  transform: rotate(90deg);
}

.fade-enter {
  transform: rotate(-90deg);
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.menu-fade-enter-active,
.menu-fade-leave-active {
  transition: opacity 0.4s ease-out, transform 0.2s ease-in-out;
}

.menu-fade-enter,
.menu-fade-leave-active {
  opacity: 0;
}

.header-container {
  a {
    transition: color 0.3s ease-out;
  }

  .router-link-active {
    color: orange !important;
  }
}
</style>